<template>
  <div>
    <p>Terms only available in German at the moment. The terms in German apply.</p>
  </div>
</template>
<script>
export default {
  name: "TermsEnglish"
}
</script>
